export default __webpack_public_path__ + "static/media/Icon_Time_Expired.396547e3.svg";